import { forwardRef, Ref } from "react";
import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import { StyledBanner, StyledRightContainer } from "@/mds/components/banner/banner.style";
import { MdsBannerProps, MDSBannerSlotName, MDSBannerKind } from "./banner.types";
// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/css";
import { useTheme } from "@emotion/react";
import { getSlot } from "@/mds/utils/slots";
import { MDSIconButton, MDSIconButtonVariant, MDSText, MDSTextVariant, MDSTextColor } from "@/mds";

export const MDSBanner = forwardRef(function MDSBanner(
  { kind, message, iconKind, iconColor, children, onDismiss }: MdsBannerProps,
  ref: Ref<HTMLElement>
) {
  const theme = useTheme();
  const computedIconColor =
    iconColor ?? (kind === MDSBannerKind.Error ? theme.colors.text.negative : undefined);
  const iconClassName = computedIconColor
    ? css({ color: computedIconColor, fill: computedIconColor })
    : undefined;
  return (
    <StyledBanner ref={ref} kind={kind} showDismissBtn={!!onDismiss} data-mds-name="banner">
      {iconKind && <MdsIcon kind={iconKind} innerStyles={{ Icon: { className: iconClassName } }} />}
      {getSlot(children, MDSBannerSlotName.Left)}
      {message && (
        <MDSText
          variant={MDSTextVariant.ParagraphS}
          color={kind === MDSBannerKind.Error ? MDSTextColor.Negative : undefined}
        >
          {message}
        </MDSText>
      )}

      <StyledRightContainer data-component="banner-right-container">
        {getSlot(children, MDSBannerSlotName.Right)}
        {onDismiss && (
          <MDSIconButton
            iconKind={MdsIconKind.Exit}
            variant={MDSIconButtonVariant.Transparent}
            onClick={onDismiss}
          />
        )}
      </StyledRightContainer>
    </StyledBanner>
  );
});
